// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/VendasProdutos_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de /relatorios/vendas_produtos/lista (chamado 2026-0046).
 *
 * Uma lista de linhas produto×franquia, já filtrada pelo filtro global
 * (franquias + período) e restrita a ordens QUITADAS.
 *
 * NÃO traz total geral de propósito: a rede opera em três moedas e somar
 * BRL + CLP + USD produz um número que não significa nada. O agrupamento e os
 * subtotais são por país, feitos no front a partir de `pais`.
 */
import type { VendasProdutos_ListaRow } from './VendasProdutos_ListaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type VendasProdutos_ListaResponseDados = VendasProdutos_ListaRow[];

export type VendasProdutos_ListaResponse = ApiResponse<VendasProdutos_ListaResponseDados>;

registerResponseContract('VendasProdutos_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      franquia_id:   { type: 'number',  required: true },
      franquia_nome: { type: 'string',  required: true },
      pais:          { type: 'string',  required: true },
      produto_id:    { type: 'number',  required: false },
      produto_nome:  { type: 'string',  required: true },
      ordens:        { type: 'number',  required: true },
      quantidade:    { type: 'number',  required: true },
      bruto:         { type: 'number',  required: true },
      desconto:      { type: 'number',  required: true },
      liquido:       { type: 'number',  required: true },
      ticket_medio:  { type: 'number',  required: true },
    },
  },
})
